import { DATE_FULL_FORMAT } from '../../../../../constants/date'
import { NUMBER_SIZE } from '../../../../../constants/size'
import { getFileValueSize } from '../../../../File'
import { FileIconPreview } from '../../../../FileIcon'
import { toListingUserCellValue } from '../../../../RentalPortalListing'
import {
  TableCellBase,
  TableCellText,
  TableDateCell,
  TableTextCell,
  TableUserCell,
} from '../../../../Table'
import { VIEWING_DOCUMENT_COLUMN_NAME } from '../RentalPortalViewingProfileDocuments.constants'

export function renderViewingProfileDocumentsCell({
  item,
  name,
  nameCellClassName,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case VIEWING_DOCUMENT_COLUMN_NAME.Name:
      return (
        <TableCellBase {...restProps} className={nameCellClassName}>
          <FileIconPreview file={item} size={NUMBER_SIZE.size24} />
          <TableCellText value={value} />
        </TableCellBase>
      )

    case VIEWING_DOCUMENT_COLUMN_NAME.Size:
      return (
        <TableTextCell
          {...restProps}
          value={value ? getFileValueSize({ value }) : null}
        />
      )

    case VIEWING_DOCUMENT_COLUMN_NAME.Uploaded:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT}
          value={value}
        />
      )

    case VIEWING_DOCUMENT_COLUMN_NAME.UploadedBy:
      return (
        <TableUserCell {...restProps} value={toListingUserCellValue(value)} />
      )

    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
